import React from 'react';
import FlightSchedule from './FlightSchedule';
import http from 'utils/http';
import events from 'utils/evemts';
import { toast } from 'react-toastify';
// import moment from "moment";
import cookies from 'utils/cookies';
import { connect } from 'react-redux';
import { setDeleteAction } from 'store/actions/deleteAction';

const getDefaultScheduleFields = () => ({
  airline: '',
  flight_no: '',
  org: '',
  dest: '',
  platform: '',
  ac_type: '',
  std: '',
  sta: '',
  from: '',
  to: '',
  sta_next: false,
  sta_next2: false,
  mon: false,
  tue: false,
  wed: false,
  thu: false,
  fri: false,
  sat: false,
  sun: false
});

class FlightScheduleContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduleList: [],
      locationModal: false,
      scheduleFields: getDefaultScheduleFields(),
      scheduleErrors: {},
      scheduleId: 0,
      openAddSchedule: false,
      type: 'add',
      flightSettings: {
        mandatory_number: false,
        limit_input: false
      },
      filterData: [],
      filter: {},
      airlines: [],
      airlineList: [],
      locationList: [],
      scheduleOrgDest: {
        org: null,
        dest: null
      },
      selectedFlight: [],
      historyLogs: [],
      historyAnchor: null,
      historyModal: false
    };
    this.eventSource = null;
  }

  normalizeScheduleFields = (scheduleFields) => {
    const source = scheduleFields && typeof scheduleFields === 'object' ? scheduleFields : {};
    return {
      ...getDefaultScheduleFields(),
      ...source,
      sta_next: !!source.sta_next,
      sta_next2: !!source.sta_next2,
      mon: !!source.mon,
      tue: !!source.tue,
      wed: !!source.wed,
      thu: !!source.thu,
      fri: !!source.fri,
      sat: !!source.sat,
      sun: !!source.sun
    };
  };

  componentDidMount() {
    this.fetchLocations();
    this.fetchAirlines();
    this.getConfigValues();
    this.eventSource = events('admin', 'flight_schedule');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      if (msg.data && (msg.data.org == cookies.get('station_code') || msg.data.dest == cookies.get('station_code'))) {
        if (msg.action == 'ADD') {
          this.setState((prevState) => ({ scheduleList: [...prevState.scheduleList, msg.data] }), this.filterData);
        }
        if (msg.action == 'UPDATE') {
          this.setState((prevState) => {
            const scheduleList = [...prevState.scheduleList];
            const index = scheduleList.findIndex(c => c.id == msg.data.id);
            if (index === -1) return null;
            scheduleList[index] = { ...msg.data };
            return { scheduleList };
          }, this.filterData);
        }
      }
      if (msg.data && msg.action && msg.action == 'DELETE') {
        this.setState((prevState) => {
          const index = prevState.scheduleList.findIndex(c => c.id == msg.data.id);
          if (index === -1) return null;
          return { scheduleList: prevState.scheduleList.filter(c => c.id != msg.data.id) };
        }, this.filterData);
      }
    };
  }

  componentWillUnmount() {
    this.eventSource.close();
  }

  fetchSchedules = () => {
    http.get('/flight_schedule?station=' + cookies.get('station_code'))
      .then((response) => {
        this.setState({ scheduleList: response?.data?.data || [] }, () => { this.filterData(); });
      });
  };

  filterData = () => {
    const { scheduleList, filter } = this.state;
    let data = [...scheduleList];
    data = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    let airlines = scheduleList.map((a) => a.airline);
    airlines = airlines.filter((item) => this.state.airlineList.map((al) => al.code).includes(item));
    airlines = airlines.filter((item, index, self) => self.indexOf(item) === index);
    if (filter.airline && filter.airline != '') {
      data = data.filter((a) => a.airline == filter.airline && this.state.airlineList.map((al) => al.code).includes(a.airline));
    }else {
      data = data.filter((a) => this.state.airlineList.map((al) => al.code).includes(a.airline));
    }
    if (this.state.filter.search && this.state.filter.search) {
      const search = this.state.filter.search.toLowerCase();
      data = data.filter((item) => {
        return (
          item.airline?.toLowerCase().includes(search) ||
          item.flight_no?.toLowerCase().includes(search) ||
          (item.airline + item.flight_no)?.toLowerCase().includes(search) ||
          item.org?.toLowerCase().includes(search) ||
          item.dest?.toLowerCase().includes(search) ||
          item.ac_type?.toLowerCase().includes(search)
        );
      });
    }
    this.setState({
      filterData: data,
      airlines: airlines
    });
  };

  onChangeFilter = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.name]: e.target.value
      }
    }, () => this.filterData());
  };


  handleClose = (type) => {
    switch (type) {
      case 'add':
        this.setState({
          openAddSchedule: false,
          scheduleFields: getDefaultScheduleFields(),
          scheduleErrors: {},
          scheduleOrgDest: {
            org: null,
            dest: null
          },
        });
        break;
      default:
        break;
    }
  };

  fetchLocations = () => {
    http.get('/locations')
      .then((response) => {
        const locationList = response.data.data.filter((item, index, self) =>
          self.findIndex((t) => t.iata_code === item.iata_code) === index
        );
        this.setState({ locationList: locationList });
      });
  };

  fetchAirlines = () => {
    http.get(`/airline?active=${true}`)
      .then((response) => {
        this.setState({ airlineList: response.data.data }, () => {
          this.fetchSchedules();
        });
      });
  };

  onChange = (e, newvalue = null) => {
    const { name, id, value: targetValue } = e.target;
    const fieldName = name || id.split('-')[0];
    const value = newvalue?.iata_code || targetValue;
    const stn_code = cookies.get('station_code');

    if (fieldName === 'org' || fieldName === 'dest') {
      const { org, dest } = this.state.scheduleFields;
      let orgval = '';
      let destval = '';

      if (value === stn_code) {
        if (fieldName === 'org') {
          orgval = stn_code;
          destval = dest === stn_code ? '' : dest;
        } else if (fieldName === 'dest') {
          orgval = org === stn_code ? '' : org;
          destval = stn_code;
        }
      } else {
        orgval = fieldName === 'org' ? value : stn_code;
        destval = fieldName === 'dest' ? value : stn_code;
      }

      const getLocation = (iata_code) => this.state.locationList.find(c => c.iata_code === iata_code);

      this.setState({
        scheduleOrgDest: {
          org: getLocation(orgval),
          dest: getLocation(destval)
        },
        scheduleFields: {
          ...this.state.scheduleFields,
          org: orgval,
          dest: destval
        }
      });
    } else {
      this.setState({
        scheduleFields: {
          ...this.state.scheduleFields,
          [fieldName]: value
        }
      });
    }
  };

  changeDateAndTime = (element, type) => {
    let fields = {};
    if (type == 'from') {
      if (this.state.scheduleFields.to && element.format('YYYY-MM-DD') > this.state.scheduleFields.to) {
        fields = { to: element.format('YYYY-MM-DD'), };
      }
    }
    this.setState({
      scheduleFields: {
        ...this.state.scheduleFields,
        [type]: (type == 'sta' || type == 'std') ? element.target.value : element.format('YYYY-MM-DD'),
        ...fields
      }
    });
  };

  changeCheck = (e) => {
    const { name, checked } = e.target;
    let others = {};

    if (name === 'all') {
      others = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
        .reduce((acc, day) => ({
          ...acc,
          [day]: checked 
        }), {});
    }

    this.setState((prevState) => ({
      scheduleFields: {
        ...prevState.scheduleFields,
        ...others,
        [name]: checked
      }
    }));
  };

  updateSchedule = async (id, data) => {
    await http.put('/flight_schedule/' + id, data)
      .then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            scheduleFields: getDefaultScheduleFields(),
            openAddSchedule: false,
            type: 'add'
          });
        }
      });
  };

  deleteSchedule = async (id) => {
    await http.delete('/flight_schedule/' + id).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
      }
    });
  };

  handleDelete = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteSchedule(id),
    });
  };


  getConfigValues = async () => {
    http.get('/settings?key=flight_schedule')
      .then((response) => {
        // handle success
        if (response.data.data) {
          this.setState({ flightSettings: response.data.data.value });
        }
      });
  };

  changeSettings = (e) => {
    const name = e.target.name;
    this.setState({
      flightSettings: {
        ...this.state.flightSettings,
        [name]: !this.state.flightSettings[name]
      }
    }, () => this.setSettingsValues(this.state.flightSettings));
  };

  setSettingsValues = async (formData) => {
    await http.put('/settings?key=flight_schedule', formData);
  };

  addEditSchedule = async (e) => {
    e.preventDefault();
    let formdata = { ...this.state.scheduleFields };
    if (this.validation()) {
      if (this.state.scheduleId) {
        this.updateSchedule(this.state.scheduleId, formdata);
      } else {
        await http.post('/flight_schedule', formdata)
          .then(({ data }) => {
            if (data.status == 'success')
              this.setState({
                scheduleFields: getDefaultScheduleFields(),
                scheduleOrgDest: {
                  org: null,
                  dest: null
                },
                openAddSchedule: false
              });
          });
      }
    }
  };

  handleUpload = (e) => {
    //take csv file and upload
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    http.post('/flight_schedules', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(({ data }) => {
      this.fetchSchedules();
      this.setState({ locationModal: false });
      const conflicts = data?.data?.conflicts || [];
      if (conflicts.length > 0) {
        toast.error(
          <div className='flight-conflict-toast'>
            <div className='flight-conflict-toast__title'>Flight schedule conflicts</div>
            <div className='flight-conflict-toast__list'>
              {conflicts.map((conflict, index) => {
                const incoming = conflict.incoming || {};
                return (
                  <div className='flight-conflict-toast__item' key={`${incoming.airline || 'flight'}-${incoming.flight_no || index}-${index}`}>
                    <span className='flight-conflict-toast__flight'>
                      {incoming.airline || ''} {incoming.flight_no || ''}
                    </span>
                    <span className='flight-conflict-toast__route'>
                      {incoming.org || ''} → {incoming.dest || ''}
                    </span>
                    <span className='flight-conflict-toast__period'>
                      {incoming.from || ''} → {incoming.to || ''}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>,
          {
            autoClose: 8000,
            closeOnClick: true,
          }
        );
      }
    });
  };

  validation = () => {
    const scheduleFields = { ...this.state.scheduleFields };
    const error = {};
    let formValid = true;
    if (!scheduleFields.airline || (scheduleFields.airline == '')) {
      formValid = false;
      error.airline = true;
    }
    if (!scheduleFields.flight_no || (scheduleFields.flight_no.trim().length === 0)) {
      formValid = false;
      error.flight_no = true;
    }
    if (!scheduleFields.org || (scheduleFields.org.trim().length === 0)) {
      formValid = false;
      error.org = true;
    }
    if (!scheduleFields.dest || (scheduleFields.dest.trim().length === 0)) {
      formValid = false;
      error.dest = true;
    }
    if (!scheduleFields.platform || (scheduleFields.platform.trim().length === 0)) {
      formValid = false;
      error.platform = true;
    }
    if (!scheduleFields.ac_type || (scheduleFields.ac_type.trim().length === 0)) {
      formValid = false;
      error.ac_type = true;
    }
    if (!scheduleFields.std || (scheduleFields.std.trim().length === 0)) {
      formValid = false;
      error.std = true;
    }
    if (!scheduleFields.sta || (scheduleFields.sta.trim().length === 0)) {
      formValid = false;
      error.sta = true;
    }
    if (!scheduleFields.from || (scheduleFields.from.trim().length === 0)) {
      formValid = false;
      error.from = true;
    }
    if (!scheduleFields.to || (scheduleFields.to.trim().length === 0)) {
      formValid = false;
      error.to = true;
    }
    this.setState({ scheduleErrors: error });
    return formValid;
  };

  handleOpen = (type, scheduleFields) => {
    switch (type) {
      case 'add':
        this.setState({
          openAddSchedule: true,
          scheduleFields: getDefaultScheduleFields(),
          scheduleOrgDest: {
            org: null,
            dest: null
          },
          type: 'add',
          scheduleId: 0
        });
        break;
      case 'edit': {
        const normalizedScheduleFields = this.normalizeScheduleFields(scheduleFields);
        this.setState({
          openAddSchedule: true,
          scheduleId: scheduleFields.id,
          scheduleFields: normalizedScheduleFields,
          scheduleOrgDest: {
            org: this.state.locationList.find(c => c.iata_code === normalizedScheduleFields.org) || null,
            dest: this.state.locationList.find(c => c.iata_code === normalizedScheduleFields.dest) || null
          },
          type: 'edit'
        });
        break;
      }
      default:
        break;
    }
  };

  setActive = (id, active) => {
    this.updateSchedule(id, { active });
  };

  handleRowClick = (row) => {
    let selectedFlight = [...this.state.selectedFlight];
    let flightIndex = selectedFlight.findIndex(f => f.id === row.id);
    if (flightIndex === -1) {
      this.setState(prevState => ({
        selectedFlight: [
          ...prevState.selectedFlight,
          { ...row }
        ]
      }));
    }
    else {
      selectedFlight.splice(flightIndex, 1);
      this.setState({ selectedFlight });
    }
  };

  handleBulkDelete = () => {
    const { selectedFlight } = this.state;
    let data = { ids: selectedFlight.map(f => f.id) };
    http.post('/bulk_delete', data);
  };


  render() {
    return (
      <>
        <FlightSchedule
          filter={this.state.filter}
          onChangeFilter={this.onChangeFilter}
          airlines={this.state.airlines}
          scheduleList={this.state.filterData}
          handleClose={this.handleClose}
          locationModal={this.state.locationModal}
          handleOpen={this.handleOpen}
          onChange={this.onChange}
          openAddSchedule={this.state.openAddSchedule}
          scheduleFields={this.state.scheduleFields}
          scheduleErrors={this.state.scheduleErrors}
          addSchedule={this.addEditSchedule}
          type={this.state.type}
          changeDateTime={this.changeDateAndTime}
          changeCheck={this.changeCheck}
          handleDelete={this.handleDelete}
          changeSettings={this.changeSettings}
          flightSettings={this.state.flightSettings}
          airlineList={this.state.airlineList}
          locationList={this.state.locationList}
          scheduleOrgDest={this.state.scheduleOrgDest}
          filterData={this.filterData}
          handleUpload={this.handleUpload}
          handleRowClick={this.handleRowClick}
          selectedFlight={this.state.selectedFlight}
          handleBulkDelete={this.handleBulkDelete}
        />
      </>
    );
  }
}


const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(null, mapDispatchToProps)(FlightScheduleContainer);